import { ErrorBoundary } from '@monorepo/shared/componentsV2/ErrorBoundary';
import { RoutesWith404 } from '@monorepo/shared/componentsV2/RoutesWith404';
import React from 'react';
import { Route } from 'react-router-dom';
import { SiteDocumentsPage } from './components/SiteDocumentsPage/SiteDocumentsPage';
import { SiteFolderDocumentsPage } from './components/SiteFolderDocumentsPage/SiteFolderDocumentsPage';

export function SiteDocumentsRouter() {
  return (
    <RoutesWith404>
      <Route
        index
        element={
          <ErrorBoundary>
            <SiteDocumentsPage />
          </ErrorBoundary>
        }
      />
      <Route
        path=":folderId"
        element={
          <ErrorBoundary>
            <SiteFolderDocumentsPage />
          </ErrorBoundary>
        }
      />
    </RoutesWith404>
  );
}
